<div #projectTeacherModal
  class="modal fade subject-management-create-teacher-modal subject-management-create-project-teacher-modal project-teacher-design-modal"
  tabindex="-1" aria-labelledby="subject-management-create-project-teacher-modal-title" aria-hidden="true">
  <div
    class="modal-dialog modal-dialog-centered subject-management-create-teacher-modal-dialog project-teacher-design-dialog">
    <div class="modal-content subject-management-create-teacher-modal-content project-teacher-design-content">
      <div class="subject-management-create-teacher-modal-header project-teacher-design-header">
        <h5 id="subject-management-create-project-teacher-modal-title">ข้อมูลผู้สอน</h5>
        <button type="button" class="subject-management-create-teacher-modal-close project-teacher-design-close"
          aria-label="ปิด" (click)="cancelProjectTeacher.emit()">
          &times;
        </button>
      </div>

      <form [formGroup]="projectTeacherForm">
        <div class="subject-management-create-teacher-modal-body project-teacher-design-body">
          <div class="project-teacher-design-grid project-teacher-design-grid-two">
            <div class="subject-management-create-field">
              <app-select label="ชื่อ - นามสกุล" formControlName="userId" [required]="true" [options]="teacherOptions"
                bindLabel="fullName" bindValue="id" [searchable]="true" [clearable]="true"
                [error]="hasProjectTeacherError('userId')" errorMessage="กรุณากรอกข้อมูล"
                inputClass="subject-management-create-select" classes="mb-0"
                (valueChange)="projectTeacherSelected.emit($event)"></app-select>
            </div>

            <div class="subject-management-create-field">
              <app-input formControlName="department" label="สาขาวิชา" [required]="true" [isDisabled]="true"
                inputClass="subject-management-create-input" classes="mb-0"></app-input>
            </div>
          </div>

          <div class="project-teacher-design-teaching-times" formArrayName="teachingTimes">
            <div class="project-teacher-design-time-row"
              *ngFor="let time of projectTeachingTimes.controls; let timeIndex = index" [formGroupName]="timeIndex">
              <div class="subject-management-create-field">
                <app-select label="วันที่สอน" formControlName="teachingDay" [required]="true"
                  [options]="teachingDayOptions" [searchable]="false" [clearable]="true"
                  [error]="hasProjectTeachingTimeError(time, 'teachingDay')" errorMessage="กรุณากรอกข้อมูล"
                  inputClass="subject-management-create-select" classes="mb-0"
                  (valueChange)="teachingTimeChanged.emit()"></app-select>
              </div>

              <div class="subject-management-create-field">
                <app-select label="เวลาสอน" formControlName="startTime" [required]="true" [options]="timeOptions"
                  [searchable]="false" [clearable]="true" [error]="hasProjectTeachingTimeError(time, 'startTime')"
                  errorMessage="กรุณากรอกข้อมูล" inputClass="subject-management-create-select" classes="mb-0"
                  (valueChange)="teachingTimeChanged.emit()"></app-select>
              </div>

              <span class="project-teacher-design-time-separator">ถึง</span>

              <div class="subject-management-create-field project-teacher-design-end-time">
                <app-select formControlName="endTime" [labelMode]="LabelMode.NO_LABEL" [options]="timeOptions"
                  [searchable]="false" [clearable]="true" [required]="true"
                  [error]="hasProjectTeachingTimeError(time, 'endTime')" errorMessage="กรุณากรอกข้อมูล"
                  inputClass="subject-management-create-select" classes="mb-0" aria-label="เวลาสอน"
                  (valueChange)="teachingTimeChanged.emit()"></app-select>
              </div>

              <div class="project-teacher-design-action-cell">
                <button *ngIf="timeIndex === 0" type="button"
                  class="app-button app-button-outline subject-management-create-add-time-button project-teacher-design-add-time-button"
                  (click)="addTeachingTime.emit()">
                  <span class="app-button-icon" aria-hidden="true">+</span>
                  เพิ่มวันและเวลาสอน
                </button>

                <button *ngIf="timeIndex > 0" type="button"
                  class="app-button app-button-icon-only subject-management-create-remove-time-button project-teacher-design-remove-time-button"
                  aria-label="ลบวันและเวลาสอน" (click)="removeTeachingTime.emit(timeIndex)">
                  <img src="assets/media/icons/svg/trush.svg" alt="" aria-hidden="true" />
                </button>
              </div>
            </div>

            <div class="subject-management-create-time-error project-teacher-design-time-error"
              *ngIf="getProjectTeachingTimesError() && (projectTeacherSubmitted || projectTeachingTimes.dirty || projectTeachingTimes.touched)">
              {{ getProjectTeachingTimesError() }}
            </div>
          </div>

          <div class="project-teacher-design-grid project-teacher-design-grid-three">
            <div class="subject-management-create-field">
              <app-input formControlName="workloadHours" label="ชั่วโมงที่สอน" [required]="true" [isDisabled]="true"
                inputClass="subject-management-create-input" classes="mb-0"></app-input>
            </div>

            <div class="subject-management-create-field">
              <app-input formControlName="primaryStudentCount" label="จำนวนนักศึกษาที่ปรึกษาหลัก" [required]="true"
                mask="separator.0" inputClass="subject-management-create-input" classes="mb-0"
                [error]="hasProjectTeacherError('primaryStudentCount') ? { required: true } : null"></app-input>
            </div>

            <div class="subject-management-create-field">
              <app-input formControlName="coStudentCount" label="จำนวนนักศึกษาที่ปรึกษาร่วม" [required]="true"
                mask="separator.0" inputClass="subject-management-create-input" classes="mb-0"
                [error]="hasProjectTeacherError('coStudentCount') ? { required: true } : null"></app-input>
            </div>
          </div>

          <div class="project-teacher-design-description-row">
            <div class="subject-management-create-field project-teacher-design-description">
              <label class="subject-management-create-label" for="project-teacher-description">
                คำอธิบาย <span aria-hidden="true">*</span>
              </label>
              <textarea id="project-teacher-description"
                class="form-control subject-management-create-input subject-management-create-textarea project-teacher-design-textarea"
                formControlName="description" [class.is-invalid]="hasProjectTeacherError('description')"></textarea>
              <div class="invalid-feedback" *ngIf="hasProjectTeacherError('description')">กรุณากรอกข้อมูล</div>
            </div>

            <label class="subject-management-create-checkbox-option project-teacher-design-checkbox">
              <input type="checkbox" formControlName="showInSchedule" />
              <span>แสดงในตารางสอน</span>
            </label>
          </div>
        </div>

        <div class="subject-management-create-teacher-modal-footer project-teacher-design-footer">
          <button type="button" class="app-button subject-management-create-teacher-modal-cancel"
            (click)="cancelProjectTeacher.emit()">
            ยกเลิก
          </button>
          <button type="button" class="app-button app-button-primary subject-management-create-teacher-modal-save"
            (click)="saveProjectTeacher.emit()">
            บันทึก
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
